export function initPages() {
    console.log('Pages initialized!')
}